// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PublicLayout__root--CNlY {
    position: relative;
    margin: 0 auto;
    width: 100%;
    background-color: var(--tertiary-color);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.PublicLayout__header--K90W {
    display: flex;
    min-height: 64px;
}

.PublicLayout__footer--sLYS {
    border-top: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/layouts/PublicLayout/PublicLayout.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,uCAAuC;IACvC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".root {\n    position: relative;\n    margin: 0 auto;\n    width: 100%;\n    background-color: var(--tertiary-color);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.header {\n    display: flex;\n    min-height: 64px;\n}\n\n.footer {\n    border-top: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PublicLayout__root--CNlY`,
	"header": `PublicLayout__header--K90W`,
	"footer": `PublicLayout__footer--sLYS`
};
export default ___CSS_LOADER_EXPORT___;
